import { useContext } from "react";
import { TitleContext } from "../../contexts/TitleContext";
import {
  Box,
  Typography,
  Stack,
  IconButton,
  alpha,
  useTheme,
} from "@mui/material";
import { Menu as MenuIcon } from "@mui/icons-material";
import ProfilePopover from "./popovers/ProfilePopover";
import NotificationsPopover from "./popovers/NotificationsPopover";
import { LogoSVG } from "../../assets/svg/SvgIcons";

interface DashboardNavbarProps {
  onMenuToggle?: () => void;
}

const DashboardNavbar = ({ onMenuToggle }: DashboardNavbarProps) => {
  const { title } = useContext(TitleContext);
  const theme = useTheme();

  return (
    <Box
      sx={{
        height: 60,
        px: 2,
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        bgcolor: "background.paper",
        zIndex: 11,
        position: "relative",
        boxShadow: `0 1px 3px ${alpha(theme.palette.common.black, 0.08)}`,
        borderBottom: "1px solid",
        borderColor: "divider",
      }}
    >
      {/* Hamburger — mobile only */}
      <IconButton
        onClick={onMenuToggle}
        size="small"
        sx={{
          display: { md: "none" },
          color: "text.primary",
          border: "1px solid",
          borderColor: "divider",
          borderRadius: 1.5,
          p: 0.75,
          "&:hover": {
            bgcolor: alpha(theme.palette.primary.main, 0.06),
          },
        }}
      >
        <MenuIcon sx={{ fontSize: 20 }} />
      </IconButton>

      {/* Logo — mobile only */}
      <Box sx={{ display: { md: "none" } }}>
        <LogoSVG width={36} height={28} />
      </Box>

      {/* Page Title */}
      <Box sx={{ flexGrow: 1 }}>
        <Typography variant="subtitle1" fontWeight={700} lineHeight={1.2}>
          {title}
        </Typography>
      </Box>

      {/* Right side */}
      <Stack direction="row" spacing={1} alignItems="center">
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{
            display: { xs: "none", md: "block" },
            borderRight: "1px solid",
            borderColor: "divider",
            pr: 1.5,
            mr: 0.5,
          }}
        >
          Simplifying the way you invest
        </Typography>

        <NotificationsPopover />

        <ProfilePopover />
      </Stack>
    </Box>
  );
};

export default DashboardNavbar;